// src/components/ServicesSection.jsx
import React from "react";
import servicesData from "../../assets/servicesData";
import { useNavigate } from "react-router-dom";

// Reusable Card Component
const ServiceCard = ({ icon, title, description, imageSrc }) => {
  const navigate = useNavigate();

  const handleNavigateToService = () => {
    navigate(`/`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="group p-8 rounded-xl h-full flex flex-col justify-between shadow-md border hover:border-t-4 hover:border-gray-900 hover:bg-gray-900/80 hover:text-white transition-all duration-300">
      <div>
        <div className="w-12 h-12 flex items-center justify-center bg-gray-100 text-gray-900 rounded-full mb-6 group-hover:bg-white group-hover:text-gray-900 transition duration-300">
          {icon}
        </div>

        <h3 className="text-xl font-semibold mb-2 text-gray-900 group-hover:text-white">
          {title}
        </h3>
        <p className="text-gray-600 group-hover:text-gray-300 mb-6 text-base">
          {description}
        </p>

        <div className="mb-6 h-48 overflow-hidden rounded-lg">
          <img
            src={imageSrc}
            alt={title}
            className="w-full h-full object-cover transition duration-300 group-hover:scale-105"
          />
        </div>
      </div>

      <button
        onClick={handleNavigateToService}
        className="flex items-center justify-between px-4 py-3 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-700 transition duration-300 group-hover:bg-white group-hover:text-gray-900"
      >
        <span>Learn more</span>
        <svg
          className="w-4 h-4 transform group-hover:translate-x-1 transition duration-200"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M14 5l7 7m0 0l-7 7m7-7H3"
          ></path>
        </svg>
      </button>
    </div>
  );
};

const ServicesSection = () => {
  return (
    <section className="py-24 bg-gray-50 font-sans">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
          <div>
            <span className="text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 px-3 py-1 rounded-full mb-4 inline-block">
              All-in-One Services
            </span>
            <h2 className="text-5xl font-light leading-snug text-gray-900">
              Innovative solutions for <br /> real world challenges
            </h2>
          </div>
          <div className="flex items-start">
            <p className="text-lg text-gray-700 max-w-lg">
              We deliver sharp, results-driven consulting across the core areas
              of business success. Whether you’re scaling, restructuring, or
              innovating — we’re here to guide your next bold move.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              imageSrc={service.imageSrc}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
